export default __webpack_public_path__ + "assets/icons/upload-cloud.d0faed21.svg";